module.exports = __webpack_public_path__ + "static/media/Chevron-right.5edd51bb.svg";